import React from "react";

import "../css/main.css";

import HowToPack_1 from "../public/how-to-pack/how-to-pack_1.png";
import HowToPack_2 from "../public/how-to-pack/how-to-pack_2.png";
import HowToPack_3 from "../public/how-to-pack/how-to-pack_3.png";
import HowToPack_4 from "../public/how-to-pack/how-to-pack_4.png";
import HowToPack_5 from "../public/how-to-pack/how-to-pack_5.png";
import HowToPack_6 from "../public/how-to-pack/how-to-pack_6.png";
import HowToPack_7 from "../public/how-to-pack/how-to-pack_7.png";

import HowToPackIcon_1 from "../public/how-to-pack/how-to-pack-icon_1.png";
import HowToPackIcon_2 from "../public/how-to-pack/how-to-pack-icon_2.png";
import HowToPackIcon_3 from "../public/how-to-pack/how-to-pack-icon_3.png";
import HowToPackIcon_4 from "../public/how-to-pack/how-to-pack-icon_4.png";
import HowToPackIcon_5 from "../public/how-to-pack/how-to-pack-icon_5.png";
import HowToPackIcon_6 from "../public/how-to-pack/how-to-pack-icon_6.png";
import HowToPackIcon_7 from "../public/how-to-pack/how-to-pack-icon_7.png";


import { useContext } from "react";
import { DarkModeContext } from "../components/DarkModeProvider"


const JakSeSbalitNaHory = () => {

  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section
        className={darkMode ? "how__to--pack dark" : "how__to--pack light"}
      >
        <div className="container">
          <div className="how__to--pack--container">
            <div className="how__to--pack--heading">
              <h1 className={darkMode ? 'dark-text' : 'light-text'}>Jak se sbalit na hory?</h1>
            </div>
            <div className="how__to--pack--image">
              <img src={HowToPack_1} alt="" />
            </div>
          </div>
        </div>
      </section>

      <section className={darkMode ? "how__to--pack--sections dark" : "how__to--pack--sections light"}>
        <div className="container">
          <div className="how__to--pack--sections--container">
            <div className="how__to--pack--numbers">
              <img src={HowToPack_2} alt="" />
            </div>

            <div className="how__to--pack--content">
              <div className="how__to--pack--content--heading">
                <img src={HowToPackIcon_1} alt="" />
                <h2 className={darkMode ? 'dark-text' : 'light-text'}>Pohodlný batoh</h2>
              </div>
              <div className="how__to--pack--content--text">
                <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>🎒 Batoh o objemu 25-30l </p>
                <h6 className={darkMode ? 'dark-second-text' : 'light-second-text'}>Pohodlný batoh by měl mít: </h6>
                <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>💨 Bederní i hrudní pás ,zpevněná a odvětrávaná záda</p>
                <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>🕸️ Síťovou kapsu pro vlhké oblečení</p>
                <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>💎 Polstrovanou kapsu na cennosti</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className={darkMode ? "how__to--pack--sections dark" : "how__to--pack--sections light"}>
        <div className="container">
          <div className="how__to--pack--sections--container">
            <div className="how__to--pack--numbers">
              <img src={HowToPack_3} alt="" />
            </div>

            <div className="how__to--pack--content">
              <div className="how__to--pack--content--heading">
                <img src={HowToPackIcon_2} alt="" />
                <h2 className={darkMode ? 'dark-text' : 'light-text'}>Oblečení</h2>
              </div>
              <div className="how__to--pack--content--text">
                <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>
                  🧦 Sportovní spodní prádlo a teplé ponožky, ponožky musí být
                  vyšší než boty{" "}
                </p>
                <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>👕 Termoprádlo, které zahřeje tělo a odvede pot</p>
                <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>👕 bavlněné tričko s dlouhým i krátkým rukávem</p>
                <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>
                  👖 Turistické kalhoty, holky klidně legíny. Super jsou kalhoty
                  s odepínacími nohavicemi
                </p>
                <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>🧥 fleecka, je tenčí, lehčí a přitom zahřeje</p>
                <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>💧 Nepromokavou bundu a kalhoty</p>
                <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>🧥💧 pláštěnka</p>
                <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>🧤 Rukavice, šátek nebo nákrčník, kulicha a kšiltovku.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className={darkMode ? "how__to--pack--sections dark" : "how__to--pack--sections light"}>
        <div className="container">
          <div className="how__to--pack--sections--container">
            <div className="how__to--pack--numbers">
              <img src={HowToPack_4} alt="" />
            </div>

            <div className="how__to--pack--content">
              <div className="how__to--pack--content--heading">
                <img src={HowToPackIcon_3} alt="" />
                <h2 className={darkMode ? 'dark-text' : 'light-text'}>Boty</h2>
              </div>
              <div className="how__to--pack--content--text">
                <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>
                  🛇 Je vhodné zaměřit se na trekovou ,pohodlnou protiskluzovou
                  obuv
                </p>
                <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>
                  ✔️ v botách se musíte i po hodínach chození cítit pohodlně,
                  nesmí vás tlačit{" "}
                </p>
                <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>🧦 prodyšné ponožky, aby se vám nepotily nohy.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className={darkMode ? "how__to--pack--sections dark" : "how__to--pack--sections light"}>
        <div className="container">
          <div className="how__to--pack--sections--container">
            <div className="how__to--pack--numbers">
              <img src={HowToPack_5} alt="" />
            </div>

            <div className="how__to--pack--content">
              <div className="how__to--pack--content--heading how__to--pack--content--heading-images">
                <img src={HowToPackIcon_4} alt="" />
                <img src={HowToPackIcon_5} alt="" />
                <h2 className={darkMode ? 'dark-text' : 'light-text'}>Voda a jídlo</h2>
              </div>
              <div className="how__to--pack--content--text">
                <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>💦 min. 2l vody, v láhvi do které si pití můžeme dolít</p>
                <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>
                  🍫 na delší tůry nesmí také chybět nějaká sladkost nebo gely
                  na doplnění cukru
                </p>
                <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>
                  🍎 součástí batohu by mělo být nějaké ovoce popř. zelenina{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className={darkMode ? "how__to--pack--sections dark" : "how__to--pack--sections light"}>
        <div className="container">
          <div className="how__to--pack--sections--container">
            <div className="how__to--pack--numbers">
              <img src={HowToPack_6} alt="" />
            </div>

            <div className="how__to--pack--content">
              <div className="how__to--pack--content--heading">
                <img src={HowToPackIcon_6} alt="" />
                <h2 className={darkMode ? 'dark-text' : 'light-text'}>Lékarnička</h2>
              </div>
              <div className="how__to--pack--content--text">
                <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>
                  🤕 Obvaz, sterilní polštářky, elastické obinadlo, trojcípý
                  šátek
                </p>
                <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>✂️ pinzetu, nůžky, zavírací špendlíky</p>
                <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>🩹 pár náplastí, dezinfekci</p>
                <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>
                  💊 léky proti bolesti, žaludečním problémům, na ztlumení
                  alergické reakce a aluminiovou fólii
                </p>
                <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>🧴 opalovací krém a repelent proti hmyzu</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className={darkMode ? "how__to--pack--sections dark" : "how__to--pack--sections light"}>
        <div className="container">
          <div className="how__to--pack--sections--container">
            <div className="how__to--pack--numbers">
              <img src={HowToPack_7} alt="" />
            </div>

            <div className="how__to--pack--content">
              <div className="how__to--pack--content--heading">
                <img src={HowToPackIcon_7} alt="" />
                <h2 className={darkMode ? 'dark-text' : 'light-text'}>Potřebné věci</h2>
              </div>
              <div className="how__to--pack--content--text">
                <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>🔦 čelovka a náhradní baterie</p>
                <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>📱 mobil, powerbanka a kabel na nabíjení</p>
                <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>🗺️ když se vybije mobil, tak se hodí určite mapa</p>
                <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>
                  💵 cestovní pás, průkaz pojišťence, občanský průkaz, peníze
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default JakSeSbalitNaHory;
